import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { stdObject } from "../../data/types/stdObject";
import useScreenSize from "../../utils/getDimentions";
import { maxCalendarSize, maxMobileSize } from "../../data/main";
import { useReactToPrint } from "react-to-print";
import { useMainContext } from "../../context/MainContext";
import { getCurrentMonth } from "../../utils/getCurrentMonth";
import { startCalendar } from "../../screens/MainStructure/components/Calendar/calendarFunctions";

const checkDimValues = (sizes: stdObject) => {
  return {
    active: sizes.width <= maxCalendarSize,
    size:
      sizes.width <= maxCalendarSize
        ? sizes.width < sizes.height
          ? "v"
          : "h"
        : false,
  };
};

export default function useCalendarModal({
  open = false,
  close = () => {},
}: {
  open: boolean;
  close: (v: boolean | string) => void;
}) {
  const screenSize = useScreenSize();
  const user: any = useSelector((state: RootState) => state.data.user);
  const listRow: any = useSelector((state: RootState) => state.data.listRow);

  const [secondFlex, setSecondFlex] = useState(checkDimValues(screenSize));

  const [selected, setSelected] = useState<string>("");
  const [calendarDays, setCalendarDays] = useState<stdObject>({});
  const { logoutAction, setCalDocsList } = useMainContext();

  const loadCalendar = () => {
    startCalendar(currentMonth, {
      user,
      logoutAction,
      setCalDocsList,
      setCalendarDays,
    });
  };
  const [headerInfo, setHeaderInfo] = useState<Array<stdObject>>([]);
  const [minModalWidth, setMinModalWidth] = useState<boolean>(false);
  const [currentMonth, setCurrentMonth] = useState<string>(
    getCurrentMonth()
      .map((e: number, index: number) => (index > 0 && e < 10 ? "0" + e : e))
      .join("-"),
  );

  const squareButtons = [{ Icon: CloseIcon, onClick: close }];

  const recordsRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef: recordsRef } as any);

  useEffect(() => {
    if (open) {
      if (minModalWidth && screenSize.width > maxCalendarSize) {
        setMinModalWidth(false);
      }
      if (!minModalWidth && screenSize.width <= maxCalendarSize) {
        setMinModalWidth(true);
      }
    }
  }, [screenSize]);

  useEffect(() => {
    if (headerInfo.length > 0) {
      reactToPrintFn();
      setHeaderInfo([]);
    }
  }, [headerInfo]);

  useEffect(() => {
    const okWidth = screenSize.width <= maxCalendarSize;
    setSecondFlex({
      active: okWidth,
      size: okWidth
        ? screenSize.width < screenSize.height
          ? "v"
          : "h"
        : false,
    });
  }, [screenSize]);

  useEffect(() => {
    loadCalendar();
  }, [currentMonth]);

  useEffect(() => {
    if (listRow.type === "SEV") {
      loadCalendar();
    }
  }, [listRow]);

  const isBigScreen = screenSize.width > maxCalendarSize;
  const isMediumcreen = screenSize.width > maxMobileSize;

  return {
    selected,
    setSelected,
    secondFlex,
    calendarDays,
    setCalendarDays,
    isBigScreen,
    isMediumcreen,
    squareButtons,
    currentMonth,
    setCurrentMonth,
  };
}
